
import { defineComponent, ref, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import axios from "axios";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "HeaderSimple",
  setup() {
    const store = useStore();
    const router = useRouter();
    const menuOpen = ref(false);
    const menuRoot = ref<HTMLElement | null>(null);
    const userMandatory = ref<number | null>(null);

    let userInfo: any = null;
    try {
      userInfo = JSON.parse(localStorage.getItem("userInfo") || "null");
    } catch (error) {
      userInfo = null;
    }
    if (userInfo && userInfo.imageProfile) {
      if (userInfo.imageProfile.indexOf("http") == -1) {
        userInfo.imageProfile = process.env.VUE_APP_IMG_URL + userInfo.imageProfile;
      }
    }

    if (localStorage.getItem("id_token") != null) {
      axios
        .get(
          process.env.VUE_APP_API_URL + "/getProfile?id=" + localStorage.getItem("u_id"),
          {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          },
        )
        .then((response) => {
          userMandatory.value = response.data.data.currentSpecialistStatus;
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem("id_token");
            location.reload();
          }
        });
    }

    const toggleMenu = () => {
      menuOpen.value = !menuOpen.value;
    };

    const onClickOutside = (e: MouseEvent) => {
      if (menuRoot.value && !menuRoot.value.contains(e.target as Node)) {
        menuOpen.value = false;
      }
    };

    onMounted(() => {
      document.addEventListener("click", onClickOutside);
    });
    onBeforeUnmount(() => {
      document.removeEventListener("click", onClickOutside);
    });

    const signOut = () => {
      const isIdCardLogin = localStorage.getItem("typeLogin") === "idcard";
      store.dispatch(Actions.LOGOUT).then(() =>
        router.push({ name: isIdCardLogin ? "sign-in-idcard" : "sign-in" }),
      );
    };

    return {
      userInfo,
      userMandatory,
      menuOpen,
      menuRoot,
      toggleMenu,
      signOut,
    };
  },
  methods: {
    setAltImg(event: Event) {
      (event.target as HTMLImageElement).src = "media/avatars/blank.png";
    },
  },
});
